import React from 'react';
import cx from 'classnames';
import styles from './PreBookPriceInfo.css';
import { RUPEE_SYMBOL } from 'constants/common';
export default function PreBookPriceInfo(props) {
    const { preBookInfo } = props;
    if (!preBookInfo) {
        return null;
    }
    const { title, priceLineItems } = preBookInfo;
    if (!title || !priceLineItems || priceLineItems.length === 0) {
        return null;
    }
    return (<div className={styles['pre-book-info']}>
			<div className={styles['pre-book-title-tag']}>{title}</div>
			{priceLineItems &&
        priceLineItems.map((priceLine, index) => (<div key={index} className={styles['price-breakup-row']}>
						<div className={cx(styles['price'], { [styles['pay-now-price']]: index === 0 })}>
							{RUPEE_SYMBOL}
							{priceLine.value}
						</div>
						<div className={styles['text']}>{priceLine.label}</div>
					</div>))}
		</div>);
}
